<template>
<div>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-dialog v-model="dialog" width="700">
          <template v-slot:activator="{on}">
            <v-btn color="success" v-on="on">
              <v-icon>person_add</v-icon>
            </v-btn>
          </template>
          <NewWorker v-on:created="workerCreated($event)"></NewWorker>
        </v-dialog>
        <v-dialog></v-dialog>
      </v-flex>

      <v-flex xs12>
        <Workers ref="workers"></Workers>
      </v-flex>

    </v-layout>
  </v-container>
</div>
</template>

<script>
import i18n from '@/plugins/vuei18n'
import Messenger from "@/plugins/Messenger";
import Workers from "@/components/document/worker/Workers";
import NewWorker from "@/components/document/worker/NewWorker";
export default {
  components: {
    NewWorker,
    Workers
  },
  computed: {

  },
  data() {
    return {
      pagination: this.$store.getters.pagination,
      sections: [],
      loading: true,
      search: "",
      dialog : false

    }
  },
  methods: {
    workerCreated(worker){
      this.dialog = false
      this.$refs.workers.addWorker(worker)
    },
    goToSchemas(){
      this.$router.push({path : "/schemas"})
    },
    loadSections() {
      this.$http.get('sections').then(data => {
        this.sections = data.data
      }).finally(() => this.loading = false)
    },
    loadWorkers() {
      this.loading = true
      this.$http.get('document/workers').then(data =>{
        this.loading = false
        this.items = data.data
        this.allItems = data.data
      })
    }
  },
  created() {
    this.loadSections()
  }
}
</script>

<style scoped>

</style>
